import { Link } from 'react-router-dom';

export interface LogoProps {
  /** Where the wordmark links to. Defaults to the site root. */
  to?: string;
}

/** The ProTeam wordmark: a small block mark plus the name. */
export function Logo({ to = '/' }: LogoProps) {
  return (
    <Link to={to} className="pt-logo" aria-label="ProTeam home">
      <svg className="pt-logo__mark" viewBox="0 0 64 64" aria-hidden="true">
        <defs>
          <linearGradient id="pt-logo-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#ff9a5a" />
            <stop offset="1" stopColor="#f2622f" />
          </linearGradient>
        </defs>
        <rect x="2" y="2" width="60" height="60" rx="16" fill="url(#pt-logo-g)" />
        <rect x="16" y="34" width="16" height="14" rx="4" fill="#fff" opacity="0.95" />
        <rect x="34" y="34" width="14" height="14" rx="4" fill="#fff" opacity="0.7" />
        <rect x="24" y="18" width="16" height="14" rx="4" fill="#fff" />
      </svg>
      <span className="pt-logo__word">ProTeam</span>
    </Link>
  );
}
